import { FC, useEffect, useRef, useState } from 'react'

import { ReactComponent as ArrowIcon } from 'src/assets/svg/diagonalArrowUp.svg'
import { ReactComponent as SmileIcon } from 'src/assets/svg/uil_smile.svg'
import { Tooltip } from 'src/components/Tooltip'
import { KeywordFetchKeywordsWithStats } from 'src/services/__generated__/api'

import styles from './topPositiveKeywordCard.module.scss'

interface TopPositiveKeywordCardProps {
  hasData?: boolean
  keyword?: KeywordFetchKeywordsWithStats
  percentage?: number
}

export const TopPositiveKeywordCard: FC<TopPositiveKeywordCardProps> = ({
  hasData = false,
  keyword,
  percentage = 0,
}) => {
  const keywordRef = useRef<HTMLSpanElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  useEffect(() => {
    const el = keywordRef.current
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight)
    }
  }, [keyword])

  const name = keyword?.name
  const mentions = keyword?.positiveCount || 0

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <SmileIcon className={styles.icon} />
        <h3 className={styles.title}>Top Positive Keyword</h3>
      </div>
      <div className={styles.body}>
        {hasData && name ? (
          <>
            <div className={styles.keywordRow}>
              {isTruncated ? (
                <Tooltip
                  overlay={name}
                  overlayClassName="topCampaignTooltip"
                  placement="top"
                >
                  <span className={styles.keyword} ref={keywordRef}>
                    {name}
                  </span>
                </Tooltip>
              ) : (
                <span className={styles.keyword} ref={keywordRef}>
                  {name}
                </span>
              )}
              {!!percentage && (
                <span className={styles.badge}>
                  <ArrowIcon className={styles.arrowIcon} />
                  {percentage}%
                </span>
              )}
            </div>
            <div className={styles.mentionsRow}>
              <span className={styles.dot} />
              <span className={styles.mentions}>
                {mentions.toLocaleString()} Positive{' '}
                {mentions === 1 ? 'Mention' : 'Mentions'}
              </span>
            </div>
          </>
        ) : (
          <div className={styles.noData}>No Data</div>
        )}
      </div>
    </div>
  )
}
